<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AppIcon',
})
</script>
<template>
    <!-- 应用图标组件，接收图标key和尺寸属性 -->
    <a-avatar 
      shape="square" 
      class="custom-icon" 
      :size="size" 
      :icon="iconNode"
    />
  </template>
  
  <script lang="ts" setup name="AppIcon">
  import { defineProps, createVNode } from 'vue';
  import {
  HddOutlined,
  HomeOutlined ,
  PieChartFilled,
  EllipsisOutlined,
  FormOutlined ,
  FundProjectionScreenOutlined,
  // 基础交互
  SearchOutlined,       // 搜索
  EditOutlined,         // 编辑
  DeleteOutlined,       // 删除
  PlusOutlined,         // 添加
  MinusOutlined,        // 减少
  CheckOutlined,        // 确认
  CloseOutlined,        // 关闭
  SaveOutlined,         // 保存
  // CancelOutlined,       // 取消
  // RefreshOutlined,      // 刷新
  DownloadOutlined,     // 下载
  UploadOutlined,       // 上传
  EyeOutlined,          // 查看
  EyeInvisibleOutlined, // 隐藏
  CopyOutlined,         // 复制
  FilterOutlined,       // 筛选
  ZoomInOutlined,       // 放大
  ZoomOutOutlined,      // 缩小
  LockOutlined,         // 锁定
  UnlockOutlined,       // 解锁
  SettingOutlined,      // 设置
  // HelpOutlined,         // 帮助
  BlockOutlined,
  // 提示反馈
  InfoOutlined,         // 信息
  WarningOutlined,      // 警告
  // SuccessOutlined,      // 成功
  // ErrorOutlined,        // 错误
  BellOutlined,         // 通知
  
  // 收藏分享
  StarOutlined,         // 收藏
  HeartOutlined,        // 喜欢
  ShareAltOutlined,     // 分享
  MoreOutlined,         // 更多
  
  // 方向导航
  ArrowUpOutlined,      // 上箭头
  ArrowDownOutlined,    // 下箭头
  ArrowLeftOutlined,    // 左箭头
  ArrowRightOutlined,   // 右箭头
  BackwardOutlined,     // 后退
  ForwardOutlined,      // 前进
  
  // 文件数据
  FileOutlined,         // 文件
  FolderOutlined,       // 文件夹
  TagOutlined,          // 标签
  HistoryOutlined,      // 历史
  CalendarOutlined,     // 日历
  // ClockOutlined,        // 时钟
  
  // 位置网络
  // MapOutlined,          // 地图
  // GlobeOutlined,        // 地球
  LinkOutlined,         // 链接
  WifiOutlined,         // 网络
  CloudOutlined,        // 云
  
  // 布局展示
  MenuOutlined,         // 菜单
  AppstoreOutlined,     // 应用商店
  // GridOutlined,         // 网格
  TableOutlined,        // 表格
  // ListOutlined,         // 列表
  
  // 图表数据
  PieChartOutlined,     // 饼图
  BarChartOutlined,     // 柱状图
  DashboardOutlined,    // 仪表盘
  
  // 用户社交
  UserOutlined,         // 用户
  TeamOutlined,         // 团队
  MessageOutlined,      // 消息
  MailOutlined,         // 邮件
  
  // 设备工具
  MonitorOutlined,      // 显示器
  LaptopOutlined,       // 笔记本
  MobileOutlined,       // 手机
  CameraOutlined,       // 相机
  
  // 安全认证
  // ShieldOutlined,       // 盾牌
  KeyOutlined,          // 钥匙
  
  // 商业电商
  ShoppingCartOutlined, // 购物车
  CreditCardOutlined,   // 信用卡
  // DiscountOutlined      // 折扣
  DotChartOutlined,
  TrophyOutlined,
  ControlOutlined,
} from '@ant-design/icons-vue';
  
  // 定义图标映射表（仅保留使用到的图标）
const iconMap = {
  setting: SettingOutlined,
  user: UserOutlined,
  home: HomeOutlined,
  edit: FormOutlined,
  school: HddOutlined,
  // 基础交互
  search: SearchOutlined,
  // edit: EditOutlined,
  delete: DeleteOutlined,
  plus: PlusOutlined,
  minus: MinusOutlined,
  check: CheckOutlined,
  close: CloseOutlined,
  save: SaveOutlined,
  // cancel: CancelOutlined,
  // refresh: RefreshOutlined,
  download: DownloadOutlined,
  upload: UploadOutlined,
  view: EyeOutlined,
  hide: EyeInvisibleOutlined,
  copy: CopyOutlined,
  filter: FilterOutlined,
  zoomIn: ZoomInOutlined,
  zoomOut: ZoomOutOutlined,
  lock: LockOutlined,
  unlock: UnlockOutlined,
  
  // help: HelpOutlined,
  
  // 提示反馈
  info: InfoOutlined,
  warning: WarningOutlined,
  // success: SuccessOutlined,
  // error: ErrorOutlined,
  notify: BellOutlined,
  
  // 收藏分享
  star: StarOutlined,
  heart: HeartOutlined,
  share: ShareAltOutlined,
  more: MoreOutlined,
  
  // 方向导航
  arrowUp: ArrowUpOutlined,
  arrowDown: ArrowDownOutlined,
  arrowLeft: ArrowLeftOutlined,
  arrowRight: ArrowRightOutlined,
  backward: BackwardOutlined,
  forward: ForwardOutlined,
  
  // 文件数据
  file: FileOutlined,
  folder: FolderOutlined,
  tag: TagOutlined,
  history: HistoryOutlined,
  calendar: CalendarOutlined,
  // clock: ClockOutlined,
  
  // 位置网络
  // map: MapOutlined,
  // globe: GlobeOutlined,
  link: LinkOutlined,
  wifi: WifiOutlined,
  cloud: CloudOutlined,
  
  // 布局展示
  menu: MenuOutlined,
  appstore: AppstoreOutlined,
  // grid: GridOutlined,
  table: TableOutlined,
  // list: ListOutlined,
  
  // 图表数据
  pieChart: PieChartOutlined,
  barChart: BarChartOutlined,
  dashboard: DashboardOutlined,
  
  // 用户社交
  // user: UserOutlined,
  team: TeamOutlined,
  message: MessageOutlined,
  mail: MailOutlined,
  
  // 设备工具
  monitor: MonitorOutlined,
  laptop: LaptopOutlined,
  mobile: MobileOutlined,
  camera: CameraOutlined,
  
  // 安全认证
  // shield: ShieldOutlined,
  key: KeyOutlined,
  
  // 商业电商
  shoppingCart: ShoppingCartOutlined,
  creditCard: CreditCardOutlined,
  // discount: DiscountOutlined  
  cpu: ShareAltOutlined,
  files:DotChartOutlined,
  trophy: TrophyOutlined,
  'set-up': ControlOutlined,
};
  
  // 组件属性定义
  const props = defineProps({
    // 图标标识（对应iconMap的key）
    iconKey: {
      type: String,
      default: ''
    },
    // 图标尺寸（默认150px，与原设计一致）
    size: {
      type: Number,
      default: 150
    }
  });
  
  // 创建图标虚拟节点（封装原getIconNode逻辑）
  const iconNode = createVNode(
    // 根据iconKey获取对应图标组件，默认使用StarOutlined
    iconMap[props.iconKey as keyof typeof iconMap] || StarOutlined,
    {
      // 图标样式
      style: {
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.2s ease',
        transform: 'scale(0.95)'
      },
      // 悬停效果
      onMouseenter: (e: MouseEvent) => {
        e.currentTarget.style.transform = 'scale(1.05)';
        e.currentTarget.style.textShadow = '0 3px 6px rgba(0, 0, 0, 0.9)';
      },
      onMouseleave: (e: MouseEvent) => {
        e.currentTarget.style.transform = 'scale(0.95)';
        e.currentTarget.style.textShadow = '0 2px 4px rgba(0, 0, 0, 0.15)';
      }
    }
  );
  </script>
  
  <style scoped lang="less">
  /* 图标基础样式 */
  :deep(.ant-avatar) {
    background-color: #e5f3ff;
    border-radius: 40px !important;
    overflow: hidden;
    transition: background-color 0.2s ease;
  }
  
  /* 图标悬停背景色 */
  :deep(.ant-avatar:hover) {
    background-color: #f0f8ff;
    text-shadow: 1px 1px 2px rgba(0, 2, 2, 0.8), 0 0 2px rgba(0, 2, 2, 0.9);
  }
  
  /* 图标内部icon样式 */
  :deep(.ant-avatar .anticon) {
    font-size: 70px;
    color: #5a8fff;
    transition: color 0.2s ease;
  }
  
  /* 图标悬停时icon颜色 */
  :deep(.ant-avatar:hover .anticon) {
    color: #6bafff;
  }
  
  /* 图标描边效果 */
  :deep(.ant-avatar)::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 30%;
    height: 70%;
    border-top: 1px solid rgba(255, 255, 255);
    border-left: 1px solid rgba(255, 255, 255);
    border-radius: 40px 0 0 0;
    pointer-events: none;
    z-index: 2;
  }
  
  :deep(.ant-avatar)::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    width: 70%;
    height: 30%;
    border-right: 1px solid rgba(255, 255, 255);
    border-bottom: 1px solid rgb(255, 255, 255);
    border-radius: 0 0 40px 0;
    pointer-events: none;
    z-index: 2;
  }
  
  /* 悬停时描边效果增强 */
  :deep(.ant-avatar:hover::before),
  :deep(.ant-avatar:hover::after) {
    border-color: rgba(209, 209, 209, 0.2);
    transition: border-color 0.2s ease;
  }
  </style>
  